import moment from "moment";
import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Table,
  Button,
  Input,
  Label,
  Form,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { HiDotsVertical } from "react-icons/hi";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import * as Server from "../Server";
import TrackOrder from "./TrackOrder";
import Page from "../components/Page";
import PrintLabel from "./PrintLabel";
import PageSpinner from "../components/PageSpinner";
import NotificationSystem from "react-notification-system";
import { capitalizeFirstLetter } from "../GeneralFunctions";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";

class Orders extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      order: {},
      status: "",
      orders: [],
      page: 1,
      limit: 10,
      totalOrders: 0,
      pages: 0,
      pageNumbers: [],
      productName: "",
      trackOrderModel: false,
      printLabelModel: false,
      orderDetail: {},
      dropdownOpen: [],
      totalAllOrders: 0,
      totalNewOrders: 0,
      totalOnProcessOrders: 0,
      totalCancelledOrders: 0,
      totalCompletedOrders: 0,
      totalOnShippingOrders: 0,
    };
  }

  componentDidMount() {
    this.getOrderDetails();
  }

  getOrderDetails = async (event) => {
    if (event) event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let data = {
        orderFor: "mall",
        page: this.state.page,
        pageLimit: this.state.limit,
      };
      if (this.state.status.length > 0) {
        Object.assign(data, { itemStatus: this.state.status });
      }
      if (this.state.productName.length > 0) {
        Object.assign(data, { name: this.state.productName });
      }
      let response = await Server.request({
        url: "order/shopOrders",
        method: "POST",
        data: data,
      });
      this.setState({
        showLoader: false,
        pages: response.pages,
        orders: response.orders,
        totalOrders: response.totalOrders,
        totalAllOrders: response.totalAllOrders,
        totalNewOrders: response.totalNewOrders,
        totalOnProcessOrders: response.totalOnProcessOrders,
        totalCancelledOrders: response.totalCancelledOrders,
        totalCompletedOrders: response.totalCompletedOrders,
        totalOnShippingOrders: response.totalOnShippingOrders,
      });
      let pageNumbers = [];
      for (let page = 1; page <= response.pages; page++) {
        pageNumbers.push(page);
      }
      let dropdownOpenCheck = [];
      for (let index = 0; index < response.orders.length; index++) {
        dropdownOpenCheck.push(false);
      }
      this.setState({
        pageNumbers: pageNumbers,
        dropdownOpen: dropdownOpenCheck,
      });
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  changeStatus = async (orderId, status) => {
    let data = {
      orderId,
      status,
      orderFor: "mall",
    };
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "shop/order/updateStatus",
        method: "POST",
        data: data,
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getOrderDetails();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  refreshPagination = (page, limit) => {
    this.setState({ page: parseInt(page, 10), limit: limit }, () => {
      this.getOrderDetails();
    });
  };

  renderOrderDetailPage = async (order) => {
    this.props.history.push({
      pathname: "/orderDetail",
      state: order,
    });
  };

  toggle = (event, index) => {
    event.preventDefault();
    let dropdownOpen = this.state.dropdownOpen;
    dropdownOpen[index] = !this.state.dropdownOpen[index];
    this.setState({ dropdownOpen: dropdownOpen });
  };

  toggleprintLabelModel = (event) => {
    if (event) event.preventDefault();
    this.setState({ printLabelModel: !this.state.printLabelModel });
  };

  toggleTrackOrderModel = (event, order) => {
    if (event) event.preventDefault();
    if (order) {
      this.setState({ trackOrderModel: !this.state.trackOrderModel, order });
    } else {
      this.setState({ trackOrderModel: !this.state.trackOrderModel });
    }
  };

  render() {
    return (
      <div>
        {this.state.printLabelModel ? (
          <PrintLabel
            printLabelModel={this.state.printLabelModel}
            toggleprintLabelModel={() => this.toggleprintLabelModel()}
            order={this.state.order}
          />
        ) : this.state.trackOrderModel ? (
          <TrackOrder
            order={this.state.order}
            trackOrderModel={this.state.trackOrderModel}
            toggleTrackOrderModel={() => this.toggleTrackOrderModel()}
          />
        ) : (
          <div>
            <PageSpinner showLoader={this.state.showLoader} />
            <Page
              title="Orders"
              breadcrumbs={[{ name: "Orders", active: true }]}
            >
              <Row>
                <Col>
                  <Card className="mb-3">
                    <CardHeader>
                      <Row>
                        <Col xl={4} lg={12} md={12}>
                          <div className="d-flex">
                            <div sm={4} className="mt-2 pr-2">
                              <Label>Shown</Label>
                            </div>
                            <div sm={4}>
                              <Input
                                type="select"
                                name="pageLimit"
                                onChange={(event) => {
                                  this.refreshPagination(1, event.target.value);
                                }}
                              >
                                <option value={10}>10</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                              </Input>
                            </div>
                            <div sm={4} className="mt-2 pl-2">
                              <Label>entries</Label>
                            </div>
                          </div>
                        </Col>
                        <Col xl={4} lg={12} md={12}>
                          <div className="d-flex justify-content-center">
                            <div className="mt-2 pr-2">
                              <Label>
                                Showing{" "}
                                {!this.state.totalOrders
                                  ? 0
                                  : this.state.page * this.state.limit -
                                    (this.state.limit - 1)}{" "}
                                to{" "}
                                {this.state.page * this.state.limit >
                                this.state.totalOrders
                                  ? this.state.totalOrders
                                  : this.state.page * this.state.limit}{" "}
                                of {this.state.totalOrders}
                              </Label>
                            </div>
                          </div>
                        </Col>
                        <Col xl={4} lg={12} md={12}>
                          <div className="d-flex justify-content-end">
                            <div sm={4} className="pr-2">
                              <Button
                                className="rounded-circle"
                                disabled={this.state.page <= 1}
                                onClick={(event) =>
                                  this.refreshPagination(
                                    this.state.page - 1,
                                    this.state.limit
                                  )
                                }
                              >
                                <MdKeyboardArrowLeft size="20px"></MdKeyboardArrowLeft>
                              </Button>
                            </div>
                            <div sm={4}>
                              <Input
                                type="select"
                                value={this.state.page}
                                name="filter"
                                onChange={(event) => {
                                  this.refreshPagination(
                                    event.target.value,
                                    this.state.limit
                                  );
                                }}
                              >
                                {this.state.pageNumbers.length !== 0 ? (
                                  this.state.pageNumbers.map(
                                    (pageNumber, index) => (
                                      <option value={pageNumber} key={index}>
                                        {pageNumber}
                                      </option>
                                    )
                                  )
                                ) : (
                                  <option value={0}>0</option>
                                )}
                              </Input>
                            </div>
                            <div sm={4} className="pl-2">
                              <Button
                                className="rounded-circle"
                                disabled={this.state.page >= this.state.pages}
                                onClick={(event) =>
                                  this.refreshPagination(
                                    this.state.page + 1,
                                    this.state.limit
                                  )
                                }
                              >
                                <MdKeyboardArrowRight size="20px"></MdKeyboardArrowRight>
                              </Button>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col sm={6}>
                          <div>
                            <select
                              className="btn selectCss w-75"
                              style={{ marginBottom: "10px" }}
                              value={this.state.status}
                              onChange={(event) => {
                                this.setState(
                                  { status: event.target.value },
                                  () => this.getOrderDetails()
                                );
                              }}
                            >
                              <option value="">
                                All({this.state.totalAllOrders})
                              </option>
                              <option value="new">
                                New Order({this.state.totalNewOrders})
                              </option>
                              <option value="on process">
                                On Process({this.state.totalOnProcessOrders})
                              </option>
                              <option value="on shipping">
                                On Shipping({this.state.totalOnShippingOrders})
                              </option>
                              <option value="completed">
                                Completed({this.state.totalCompletedOrders})
                              </option>
                              <option value="cancelled">
                                Cancelled({this.state.totalCancelledOrders})
                              </option>
                            </select>
                          </div>
                        </Col>
                        <Col md={6}>
                          <Form
                            onSubmit={(event) => this.getOrderDetails(event)}
                          >
                            <div className=" d-flex float-right">
                              <Input
                                type="search"
                                value={this.state.productName}
                                placeholder="Search by name"
                                className="mr-5"
                                onChange={(event) =>
                                  this.setState({
                                    productName: event.target.value,
                                  })
                                }
                              ></Input>
                              <Button type="submit">Search</Button>
                            </div>
                          </Form>
                        </Col>
                      </Row>
                      <Table striped hover responsive>
                        <thead>
                          <tr>
                            <th>Item Name</th>
                            <th>Quantity</th>
                            <th>Purchase Date</th>
                            <th>Shipping Method</th>
                            <th>Buyer Name</th>
                            <th>Shipping address</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.orders && this.state.orders.length ? (
                            this.state.orders.map((order, index) => (
                              <tr key={index}>
                                <td>
                                  {order.items.length > 0
                                    ? order.items.map((item, index) => (
                                        <div className="d-flex" key={index}>
                                          <Label>
                                            {capitalizeFirstLetter(
                                              item.product.title || ""
                                            )}
                                          </Label>
                                          {order.items.length !== index + 1 &&
                                            ","}
                                        </div>
                                      ))
                                    : "-"}
                                </td>

                                <td>{order.items[0].quantity || "-"}</td>
                                <td>
                                  {moment
                                    .utc(order.createdAt)
                                    .format("MM-DD-YYYY")}
                                </td>
                                <td>
                                  {typeof order.items[0].shipping === "object"
                                    ? order.items[0].shipping.Service
                                    : "-"}
                                </td>
                                <td>
                                  {order.address.length > 0
                                    ? capitalizeFirstLetter(
                                        order.address[0].fullName || "-"
                                      )
                                    : ""}
                                </td>
                                <td>
                                  {order.address.length > 0 ? (
                                    <div>
                                      <p className="m-0 p-0">
                                        {order.address[0].address1 || ""}
                                      </p>
                                      <p className="m-0 p-0">
                                        {order.address[0].address2 || ""}
                                      </p>
                                      <p className="m-0 p-0">
                                        {order.address[0].postal || ""}
                                      </p>
                                    </div>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td>
                                  {capitalizeFirstLetter(
                                    order.items[0].status || "-"
                                  )}
                                </td>
                                <td>
                                  <Dropdown
                                    isOpen={this.state.dropdownOpen[index]}
                                    toggle={(event) =>
                                      this.toggle(event, index)
                                    }
                                  >
                                    <DropdownToggle
                                      tag="span"
                                      data-toggle="dropdown"
                                      aria-expanded={
                                        this.state.dropdownOpen[index]
                                      }
                                    >
                                      <HiDotsVertical
                                        style={{
                                          cursor: "pointer",
                                          marginLeft: "30%",
                                        }}
                                      />
                                    </DropdownToggle>

                                    {order.items[0].status === "new" ? (
                                      <DropdownMenu>
                                        <DropdownItem
                                          onClick={(event) =>
                                            this.renderOrderDetailPage(order)
                                          }
                                        >
                                          Detail order
                                        </DropdownItem>
                                        <DropdownItem
                                          onClick={(event) =>
                                            this.changeStatus(
                                              order._id,
                                              "on process"
                                            )
                                          }
                                        >
                                          Accept order
                                        </DropdownItem>
                                        <DropdownItem
                                          onClick={(event) =>
                                            this.changeStatus(
                                              order._id,
                                              "cancelled"
                                            )
                                          }
                                        >
                                          Reject order
                                        </DropdownItem>
                                      </DropdownMenu>
                                    ) : order.items[0].status ===
                                      "on process" ? (
                                      <DropdownMenu>
                                        <DropdownItem
                                          onClick={(event) =>
                                            this.renderOrderDetailPage(order)
                                          }
                                        >
                                          Detail order
                                        </DropdownItem>
                                        <DropdownItem
                                          onClick={(event) =>
                                            this.setState(
                                              { order: order },
                                              () =>
                                                this.toggleprintLabelModel(
                                                  event
                                                )
                                            )
                                          }
                                        >
                                          Print label
                                        </DropdownItem>
                                        <DropdownItem
                                          onClick={(event) =>
                                            this.changeStatus(
                                              order._id,
                                              "on shipping"
                                            )
                                          }
                                        >
                                          Request Pickup
                                        </DropdownItem>
                                        <DropdownItem
                                          onClick={(event) =>
                                            this.changeStatus(
                                              order._id,
                                              "cancelled"
                                            )
                                          }
                                        >
                                          Reject order
                                        </DropdownItem>
                                      </DropdownMenu>
                                    ) : ["on shipping", "arrived"].includes(
                                        order.items[0].status
                                      ) ? (
                                      <DropdownMenu>
                                        <DropdownItem
                                          onClick={(event) =>
                                            this.renderOrderDetailPage(order)
                                          }
                                        >
                                          Detail order
                                        </DropdownItem>
                                        <DropdownItem
                                          onClick={(event) =>
                                            this.toggleTrackOrderModel(
                                              event,
                                              order
                                            )
                                          }
                                        >
                                          Track
                                        </DropdownItem>
                                      </DropdownMenu>
                                    ) : (
                                      order.items[0].status === "completed" && (
                                        <DropdownMenu>
                                          <DropdownItem
                                            onClick={(event) =>
                                              this.renderOrderDetailPage(order)
                                            }
                                          >
                                            Detail order
                                          </DropdownItem>
                                        </DropdownMenu>
                                      )
                                    )}
                                  </Dropdown>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="8" className="text-center">
                                No orders found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <NotificationSystem
                dismissible={false}
                ref={(notificationSystem) =>
                  (this.notificationSystem = notificationSystem)
                }
                style={NOTIFICATION_SYSTEM_STYLE}
              />
            </Page>
          </div>
        )}
      </div>
    );
  }
}
export default Orders;
